import React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Alert from "@mui/material/Alert";
import {
  getShipmentItemLabel,
  getReservationItemSync,
} from "./reservationItemSync";

export default function ReservationItemSyncStatus({
  plan,
  receivedItems,
  workOrderNumber,
  onAddRemaining,
  addingRemaining,
}) {
  if (!plan?.applied || plan.type === "skip") {
    return null;
  }

  const sync = getReservationItemSync(receivedItems, plan.appliedShipmentItems || []);
  const reservationLabel = workOrderNumber ? `Reservation #${workOrderNumber}` : "the reservation";
  const hasAppliedItems = (plan.appliedShipmentItems || []).some(
    entry => Number(entry.quantity) > 0
  );

  if (!sync.hasReceivableItems) {
    return (
      <Alert severity="warning" sx={{ mt: 2, maxWidth: 520, width: "100%" }}>
        No received shipment items are available to add to a reservation.
      </Alert>
    );
  }

  if (sync.allSynced) {
    return (
      <Alert
        severity="success"
        sx={{
          mt: 2,
          maxWidth: 440,
          width: "100%",
          justifyContent: "center",
          "& .MuiAlert-icon": {
            alignItems: "center",
          },
          "& .MuiAlert-message": {
            textAlign: "center",
          },
        }}
      >
        <span>
          The items from this inbound shipment have been added to
          <br />
          {reservationLabel}.
        </span>
      </Alert>
    );
  }

  return (
    <Box mt={2} width="100%" maxWidth={520}>
      <Alert severity="warning" sx={{ mb: 2 }}>
        {hasAppliedItems
          ? `Some items from this inbound shipment have not been added to ${reservationLabel}. Would you like to add them?`
          : `${reservationLabel} is ready. The following items have not been added yet. Would you like to add them?`}
      </Alert>
      <Box
        border="1px solid"
        borderColor="divider"
        borderRadius={2}
        bgcolor="#f9fafb"
        px={2}
        py={1}
      >
        {sync.pending.map(({ shipmentItem, quantityToAdd }, index) => (
          <Box
            key={shipmentItem.id}
            py={1}
            borderBottom={index < sync.pending.length - 1 ? "1px solid" : "none"}
            borderColor="divider"
          >
            <Typography fontWeight={500}>{getShipmentItemLabel(shipmentItem)}</Typography>
            <Typography variant="body2" color="text.secondary">
              Qty to add: {quantityToAdd}
            </Typography>
          </Box>
        ))}
      </Box>
      {onAddRemaining && (
        <Button
          sx={{ mt: 2 }}
          variant="contained"
          onClick={onAddRemaining}
          disabled={addingRemaining}
        >
          Add Remaining Items to Reservation
        </Button>
      )}
    </Box>
  );
}
